/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React from "react"
import { Image } from "@carrotfertility/carotene"
import { ResponsiveDrawer } from "./sidebar/ResponsiveDrawer"
import { Benefit } from "../types/Benefit"
import { FormattedMessage } from "react-intl"
import { Box, Divider, Typography } from "@carrotfertility/carotene-core"

export const Heading = ({ benefit }: { benefit: Benefit }): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      width="100%"
      gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
    >
      <Box
        display="flex"
        flexDirection="row"
        gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
        alignItems="center"
      >
        <Image
          src={require(`../resources/images/icn-providers.png`)}
          srcSet={require(`../resources/images/icn-providers-2x.png`)}
          altText=""
          height={36}
          width={36}
        />
        <Typography variant="h1" color={(theme) => theme.palette.text.primary}>
          <FormattedMessage defaultMessage="Provider finder" />
        </Typography>
      </Box>
      <Divider />
      <ResponsiveDrawer benefit={benefit} />
    </Box>
  )
}
